export enum InvoicingEvent {
    INVOICE_AVAILABLE = 'invoice-available',
}

export interface IInvoiceAvailableEvent {
    url?: string;
    expiration_time?: string;
    errors?: { [invoiceReference: string]: string };
}
